// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageBox__container___xTOrA","hasIcon":"MessageBox__hasIcon___l+b96","alignCenter":"MessageBox__alignCenter___bqW9l","icon":"MessageBox__icon___QSbsV"};